/**
 * 用户相关接口
 */
import request from '../utils/axios'
import request_gispai from '../utils/axios_gispai'
/**
 * 用户注册接口
 * @param {string} name 用户名
 * @param {number} phone 手机号, 非数字注册失败
 * @param {string} key 验证码
 * @param {string} passWord 密码
 * @returns
 */
export function userRegister(params) {
  return request({
    url: '/User/Register',
    method: 'POST',
    data: params
  })
}

/**
 * 用户登录接口
 * @param {number} loginName 电话
 * @param {string} passWord 密码
 * @param {string} type TODO: 登录类型
 * @returns
 */
export function userLogin(params) {
  return request({
    url: '/User/Login',
    method: 'POST',
    data: params
  })
}

// 设置我的手机号（加工厂认证后）
export function SetMyPhone(params) {
  return request({
    url: '/User/SetMyPhone',
    method: 'post',
    data: params
  })
}

// 工作人员 手机验证码登录
export function LoginCodeByUser(params) {
  return request({
    url: '/User/LoginCode',
    method: 'post',
    data: params
  })
}

//地图派登录
export function login(params) {
  return request_gispai({
    url: 'api/User/login',
    method: 'post',
    params: params
  })
}




/**
 * 获取用户列表
 * @param {number} PageNumber 页码
 * @param {number} PageSize 每页数量
 * @returns
 */
export function getUsers(data) {
  return request({
    url: `/User/GetList`,
    method: 'post',
		data
  })
}

/**
 * 获取用户详情（工作人员）
 * @param {number} getUserCode 用户编码
 * @returns
 */
export function getUserDetail(params) {
  return request({
    url: `/User/GetUserDetails?getUserCode=${params.getUserCode}`,
    method: 'get',	
  })
}

/**
 * 通过id查询用户
 * @param {string} id 用户id
 * @returns
 */
export function getUserById(params) {
  return request({
    url: `/users/${params.id}`,
    method: 'get'
  })
}

/**
 * 通过id获取该用户的采伐证列表
 * @param {string} id 用户id
 * @returns
 */
export function getLicensesListById(params) {
  return request({
    url: `/CutLicense/GetUserLicenses?id=${params.id}`,
    method: 'get'
  })
}

/**
 * 获取用户详情
 */
export function getUserInfo(params) {
  return request({
    url: `/User/GetDetails`,
    method: 'get'
  })
}

/**
 * 发送手机验证码
 * @mobile {number} 手机号
 * @messageType {number} 类型1-注册，2-手机密码找回
 */
export function getCodeByUser(params) {
  return request({
    url: `/User/SendSms`,
    method: 'post',
		data:params
  })
}

// 获取自己的采伐者列表
export function GetUserFellList(params) {
  return request({
    url: `/User/GetUserFellList`,
    method: 'post',
		data:params
  })
}

// 获取自己的加工厂/集材场列表
export function GetUserFacList(params) {
  return request({
    url: `/User/GetUserFacList`,
    method: 'post',
		data:params
  })
}

// 按原始密码更改密码
export function changePasswordNew(params) {
  return request({
    url: `/User/ChangePasswordByOriginal`,
    method: 'post',
		data:params
  })
}

// 获取消息通知(全部：-1，未读：0，已读：1）
export function GetMessage(params) {
  return request({
    url: `/Message/GetMessage`,
    method: 'post',
		data:params
  })
}
// 获取未读消息数量
export function GetMessageCount(params) {
  return request({
    url: `/Message/GetMessageCount`,
    method: 'get'
  })
}

// 设置全部未读消息为已读
export function SetRead(params) {
  return request({
    url: `/Message/SetRead`,
    method: 'get'
  })
}

// 获取用户列表（林木溯源）
export function GetUserList(params) {
  return request({
    url: `/User/GetUserList`,
    method: 'post',
		data:params
  })
}

// 获取用户详情(根据用户明细权限)
export function GetDetailsByYHMX(params) {
  return request({
    url: `/User/GetDetailsByYHMX`,
    method: 'post',
		data:params
  })
}

// 获取所有加工厂列表（根据用户明细权限)
export function GetAllFacList(params) {
  return request({
    url: `/User/GetAllFacList`,
    method: 'post',
		data:params
  })
}

// 获取加工厂详情(根据用户明细权限)
export function GetFacDetailsByYHMX(id) {
  return request({
    url: `/User/GetFacDetailsByYHMX?id=${id}`,
    method: 'get'
  })
}

// 获取用户经营列表（根据用户明细权限)
export function GetAllFellList(params) {
  return request({
    url: "/User/GetAllFellList",
    method: 'post',
		data:params
  })
}

// 获取部门列表
export function GetDepartmentList() {
  return request({
    url: "/Staff/GetDepartmentList",
    method: 'get'
  })
}

// 修改部门名称
export function UpdateDepartment(params) {
  return request({
    url: "/Staff/UpdateDepartment",
    method: 'post',
		data:params
  })
}


// 添加部门
export function AddDepartment(params) {
  return request({
    url: "/Staff/AddDepartment",
    method: 'post',
		data:params
  })
}

// 删除部门
export function DeleDepartment(id) {
  return request({
    url: `/Staff/DeleDepartment?id=${id}`,
    method: 'get'
  })
}


/**
 * 工作人员登录接口
 * @param {number} loginName 电话
 * @param {string} passWord 密码
 * @param {string} type TODO: 登录类型
 * @returns
 */
 export function workUserLogin(params) {
  return request({
    url: '/Staff/Login2',
    method: 'POST',
    data: params
  })
}

// 普通用户相关的接口

// 获取消息通知(全部：-1，未读：0，已读：1）
export function GetMessage2(params) {
  return request({
    url: `/Message/GetMessage2`,
    method: 'post',
		data:params
  })
}
// 获取未读消息数量
export function GetMessageCount2(params) {
  return request({
    url: `/Message/GetMessageCount2`,
    method: 'get'
  })
}

// 设置全部未读消息为已读
export function SetRead2(params) {
  return request({
    url: `/Message/SetRead2`,
    method: 'get'
  })
}

// 修改登录类型
export function UpdateUserLoginType(params) {
  return request({
    url: `/User/UpdateUserLoginType`,
    method: 'post',
		data:params
  })
}

// 添加设计公司(工作人员)
export function AddCompany(params) {
  return request({
    url: `/User/AddCompany`,
    method: 'post',
		data:params
  })
}

// 修改集材场/加工厂信息（工作人员）
export function UpdateFac(params) {
  return request({
    url: `/User/UpdateFac`,
    method: 'post',
		data:params
  })
}

// 获取所有加工厂位置信息
export function GetFacPoints() {
  return request({
    url: `/User/GetFacPoints`,
    method: 'get'
  })
}

// 更改用户密码，根据验证码生成的key
export function ChangePasswordForceByUser(params) {
  return request({
    url: `/User/ChangePasswordForce`,
    method: 'post',
		data:params
  })
}

// 前端每60分钟对接一次地图派token (普通用户)
export function GetMyMapToken2(params) {
  return request({
    url: `/User/GetMyMapToken?token=${params}`,
    method: 'get'
  })
}

// 删除普通人员（工作人员）
export function DeleteUser(delcode){
	return request({
		url: `/User/DeleteUser?delcode=${delcode}`,
		method: 'get'
	})
}

// 修改关联账号（登录账号，采伐者，伐区）手机号（工作人员）
export function SetAssociatedPhone(params) {
  return request({
    url: `/User/SetAssociatedPhone`,
    method: 'post',
		data:params
  })
}